export default __webpack_public_path__ + "static/media/paintprogram.ee26a4ef.png";